import {
  GET_CEREMONY_PACK_PROFILE,
  GET_CEREMONY_PACK_PROFILE_FAIL,
  GET_CEREMONY_PACK_PROFILE_SUCCESS,
  GET_CEREMONIES_PACK,
  GET_CEREMONIES_PACK_FAIL,
  GET_CEREMONIES_PACK_SUCCESS,
  ADD_NEW_CEREMONY_PACK,
  ADD_CEREMONY_PACK_SUCCESS,
  ADD_CEREMONY_PACK_FAIL,
  UPDATE_CEREMONY_PACK,
  UPDATE_CEREMONY_PACK_SUCCESS,
  UPDATE_CEREMONY_PACK_FAIL,
  DELETE_CEREMONY_PACK,
  DELETE_CEREMONY_PACK_SUCCESS,
  DELETE_CEREMONY_PACK_FAIL,
} from "./actionTypes"

export const getCeremonies_pack = ({offset='',page_size=''}) => ({
  type: GET_CEREMONIES_PACK,
  payload:{offset,page_size}
})

export const getCeremonies_packSuccess = ceremonies_pack => ({
  type: GET_CEREMONIES_PACK_SUCCESS,
  payload: ceremonies_pack,
})

export const getCeremonies_packFail = error => ({
  type: GET_CEREMONIES_PACK_FAIL,
  payload: error,
})

export const addNewCeremony_pack = user => ({
  type: ADD_NEW_CEREMONY_PACK,
  payload: user,
})

export const addCeremony_packSuccess = user => ({
  type: ADD_CEREMONY_PACK_SUCCESS,
  payload: user,
})  

export const addCeremony_packFail = error => ({
  type: ADD_CEREMONY_PACK_FAIL,
  payload: error,
})

export const updateCeremony_pack = user => ({
  type: UPDATE_CEREMONY_PACK,
  payload: user,
})

export const updateCeremony_packSuccess = user => ({
  type: UPDATE_CEREMONY_PACK_SUCCESS,
  payload: user,
})

export const updateCeremony_packFail = error => ({
  type: UPDATE_CEREMONY_PACK_FAIL,
  payload: error,
})

export const deleteCeremony_pack = user => ({
  type: DELETE_CEREMONY_PACK,
  payload: user,
})

export const deleteCeremony_packSuccess = user => ({
  type: DELETE_CEREMONY_PACK_SUCCESS,
  payload: user,
})

export const deleteCeremony_packFail = error => ({
  type: DELETE_CEREMONY_PACK_FAIL,
  payload: error,
})

export const getCeremony_packProfile = () => ({
  type: GET_CEREMONY_PACK_PROFILE,
})

export const getCeremony_packProfileSuccess = userProfile => ({
  type: GET_CEREMONY_PACK_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getCeremony_packProfileFail = error => ({
  type: GET_CEREMONY_PACK_PROFILE_FAIL,
  payload: error,
})
